<div class="container-fluid">
    <div class="row">

        <div class="col-md-6 col-offset-2">
            <mat-card>Add Project</mat-card>

            <mat-card class="registerForm">
                <form class="example-form" [formGroup]="addProject">
                    <div class="row">
                        <mat-form-field class="example-full-width col-md-12">
                            <input matInput placeholder="Project name" formControlName="project">
                        </mat-form-field>


                        <div class="text-danger col-md-12"
                            *ngIf="addProject['controls']['project']['invalid'] && addProject['controls']['project']['touched']">
                            Please enter Project Name
                        </div>
                    </div>
                    <div class="row register">
                        <button class="col-md-12" [disabled]="!addProject.valid" (click)="onSubmitUser()" type="button"
                            mat-raised-button color="primary">Add Project</button>

                    </div>




                </form>
            </mat-card>
        </div>

    </div>
</div>